<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="工艺路线编号">
					<c-input name="route_code"></c-input>
				</m-search-item>
				<m-search-item label="工艺路线名称">
					<c-input name="route_name"></c-input>
				</m-search-item>
				<m-search-item label="包含工序">
					<c-select name="process_ids" multiple async @search="searchProcess"></c-select>
				</m-search-item>
				<m-search-item label="备注">
					<c-input name="remark"></c-input>
				</m-search-item>
			</m-search>

			<m-operate :batch="batchData.length" @batchCancel="batchCancel">
				<c-button color="main" v-if="auth('b_processroute_edit')" v-lock="lock('b_processroute_edit')" prepend-icon="tf-add" @click="globalDialog('processRouteEdit', $refs.list.update)">创建工艺路线</c-button>
				<c-button v-if="auth('b_processroute_export')" v-lock="lock('b_processroute_export')"  prepend-icon="tf-export" @click="exportListByViewId()">导出</c-button>
				<c-button v-if="auth('b_processroute_export')" v-lock="lock('b_processroute_export')" prepend-icon="tf-export" @click="exportListByViewId(3)">按模板导出</c-button>
				<c-button v-if="auth('b_processroute_edit')" v-lock="lock('b_processroute_edit')" prepend-icon="tf-import" @click="excelImport()">导入</c-button>
				
				<template #batch>
					<c-button v-if="auth('b_processroute_export')" v-lock="lock('b_processroute_export')"  prepend-icon="tf-export" @click="exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_processroute_export')" v-lock="lock('b_processroute_export')" prepend-icon="tf-export" @click="exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_processroute_edit')" v-lock="lock('b_processroute_edit')" prepend-icon="tf-trash" color="red" :hollow="true" @click="batchRemoveProcessRoute">删除</c-button>
				</template>
				
				<template #right>
					<c-button v-if="auth('b_processroute_log')" v-lock="lock('b_processroute_log')" prepend-icon="tf-import-record" @click="loadImportLogDetail()">导入记录</c-button>
					<c-button v-if="auth('b_processroute_log')" v-lock="lock('b_processroute_log')" prepend-icon="tf-operate-record" @click="loadWorkLogDetail()">操作记录</c-button>
				</template>
			</m-operate>

			<c-table ref="list" height="grow" :paging="true" width-resize>
				<c-table-column type="selector" width="32" @handle="batchSelect"></c-table-column>
				<c-table-column label="工艺路线编号" name="route_code" width="120"></c-table-column>
				<c-table-column label="工艺路线名称" name="route_name" width="200"></c-table-column>
				<c-table-column label="包含工序列表" name="process_names" width="250">
					<template #default="{data}">
						<span v-if="!data.process_names">-</span>
						<c-tags v-else class="single-line" :value="data.process_names" :title="data.process_names">
							<template #marker>
								<i class="tf">&#xeb08;</i>
							</template>
						</c-tags>
					</template>
				</c-table-column>
				<c-table-column label="关联产品列表" name="product_codes" width="250">
					<template #default="{data}">
						<span v-if="!data.product_codes">-</span>
						<c-tags v-else class="single-line" :value="data.product_codes" :title="data.product_codes"></c-tags>
					</template>
				</c-table-column>
				<c-table-column label="备注" name="remark" width="100"></c-table-column>
				<c-table-column label="创建人" name="create_user_realname" width="80"></c-table-column>
				<c-table-column label="创建时间" name="create_date" width="125"></c-table-column>
				<c-table-column
					type="button"
					label="操作"
					width="230"
                    button-limit="4"
                >
					<template #default="{data}">
						<c-table-button v-if="auth('b_processroute_edit')" v-lock="lock('b_processroute_edit')" icon="tf-edit" @click="$refs.processRouteEdit.open(data, false)">编辑</c-table-button>
						<c-table-button v-if="auth('b_processroute_edit')" v-lock="lock('b_processroute_edit')" icon="tf-copy" @click="$refs.processRouteEdit.open(data, true)">复制</c-table-button>
						<c-table-button v-if="auth('b_processroute_product_edit')" v-lock="lock('b_processroute_product_edit')" icon="tf-related" @click="$refs.processRouteProductEdit.open(data)">关联产品</c-table-button>
						<c-table-button v-if="auth('b_processroute_edit')" v-lock="lock('b_processroute_edit')" icon="tf-trash" @click="removeProcessRoute(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
			<!--创建/编辑工艺路线弹窗-->
			<process-route-edit ref="processRouteEdit" @resolve="$refs.list.update()"></process-route-edit>
			<!--创建/编辑工艺路线-关联产品信息弹窗-->
			<process-route-product-edit ref="processRouteProductEdit" @resolve="$refs.list.update()"></process-route-product-edit>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import processRouteProductEdit from "@/pages/basic/process_route_product_edit.vue";
	import processRouteEdit from "@/pages/basic/process_route_edit.vue";
	import {batchData, batchMethods} from '@/components/public/batch.js'

	export default {
		components: {
			processRouteProductEdit, processRouteEdit
		},

		data() {
			return {
				...batchData(),
				viewId:10011,
				workType:10,
				flterParams:{}
			}
		},
		
		computed: {
			// 获取dictName选项数据
			...mapState(['disableEnableDic']),
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
			...batchMethods(),

			/********搜索************/
			searchHandle(data){
				if (!data){
					data = {};
				}
				this.$refs.list.load({
					url: '/process/route/list',
					data,
					success: () => {
						this.batchData = [];
					}
				});
				this.flterParams = data;
			},

			searchProcess(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DICPROCESS_SEARCH',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/****批量删除工艺路线***/
			batchRemoveProcessRoute(){
				var ids = [];
				this.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});
				
				this.$confirm({
					message:'确认删除' + ids.length + '条工艺路线记录吗？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/process/route/remove/batch',
							data: {ids: ids},
							loading: true,
							success: data => {
								let Mtype = 'success';
								let message = '成功' + data.success_count + '条';
								if(data.fail_count > 0 && data.success_count > 0){
									Mtype = 'warn';
									message += '，失败'+data.fail_count+'条';
								}else if(data.fail_count > 0 && data.success_count == 0){
									Mtype = 'fail'
									message += '，失败'+data.fail_count+'条';
								}else{
									message = '成功删除' + data.success_count + '条记录';
								}
								this.$message({
									message: message,  // 提示内容,
									type: Mtype
								});
								//刷新
								this.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/******删除工艺路线***********/
			removeProcessRoute(data){
				this.$confirm({
					message:'确认删除工艺路线【'+data.route_name+'】？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/process/route/remove',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								this.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/**
			 * 通过视图ID导出数据
			 */
			exportListByViewId(export_type){
				var selectedRows = this.$refs.list.getRow('selected');
				var ids = [];//选中的数据行
				if (selectedRows && selectedRows.length > 0){
					ids = selectedRows.map(item => item.data.id);
				}
				this.flterParams.view_id = this.viewId;
				this.flterParams.ids = ids;//选中的数据行ID
				this.flterParams.export_type = export_type||1;//导出数据类型 1=按照视图导出列表  2=-详情  3、按模板导出列表
				if (export_type && export_type==3){
					this.exportByTemplate(export_type);
				}else {
					this.request({
						url: '/export/url',
						data: this.flterParams,
						success: data => {
							this.download({
								signFree: true,
								fileName: data.filename,
								url: data.url,
								loading: {
									message: '数据文件生成中...'
								}
							})
						}
					});
				}
			},

			// 导出数据
			exportByTemplate(templateType) {
				this.globalDialog('exportTemplateSelector',{
					props: {
						workType: this.workType,
						templateType: templateType || 2
					},
					data: {
						excelParams: this.flterParams
					}
				});
			},

			/******加载系统业务日志列表**********/
			loadWorkLogDetail(){
				//打开模板选择弹窗
				this.globalDialog('workLogDetail',{
					props: {
						workType: this.workType
					}
				});
			},

			/******导入Excel数据**********/
			excelImport(){
				//打开模板选择弹窗
				this.globalDialog('excelImport',{
					props: {
						workType: this.workType
					}
				},this.importHandle);
			},

			/*********导入成功回调****************/
			importHandle(){
				setTimeout(() => {
					this.$refs.list.update();
				}, 300);
			},

			/******加载导入业务日志列表**********/
			loadImportLogDetail(){
				//打开模板选择弹窗
				this.globalDialog('importLogDetail',{
					props: {
						workType: this.workType
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	//包含工序列表：默认仅展示一行，超出隐藏，避免工序过多撑高行（悬停 title 可查看完整列表）
	.c-tags.single-line {
		flex-wrap: nowrap;
		overflow: hidden;
	}
</style>